import { ReactEditor, RenderElementProps } from 'slate-react';
import { RealtimeSpeaker } from '@components/editors/realtime-editor/body/realtime-speaker.tsx';
import { useCallback, useState } from 'react';

type RealtimeParagraphType = {
  type: 'speaker' | 'paragraph';
  id: number;
  speaker?: string;
  offset_ms?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any[];
};

export const RealtimeParagraphElement = ({
  attributes,
  children,
  element,
  index
}: RenderElementProps & {
  editor: ReactEditor;
  index: number;
}) => {
  const customElement = element as RealtimeParagraphType;
  const { type, id, speaker, offset_ms } = customElement;
  const [localSpeaker, setLocalSpeaker] = useState(speaker || 'Speaker');

  const handleInteraction = useCallback(() => {
    window.dispatchEvent(
      new CustomEvent('realtime:activeRow', { detail: { index } })
    );
  }, [index]);

  return (
    <div>
      {type === 'speaker' ? (
        <div
          className="flex items-start w-full mb-2"
          key={id}
          {...attributes}
          contentEditable={false}
          onMouseDown={handleInteraction}
          onClick={handleInteraction}
        >
          <RealtimeSpeaker
            speaker={localSpeaker}
            offset_ms={offset_ms || 0}
            index={index}
            setSpeaker={setLocalSpeaker}
          />
        </div>
      ) : (
        <div
          {...attributes}
          className="transition-colors duration-150"
          onMouseDown={handleInteraction}
          onClick={handleInteraction}
          onFocus={handleInteraction}
        >
          {children}
        </div>
      )}
    </div>
  );
};
